import { api } from './client'
import type { CurrentUser } from '@/types'

export const authApi = {
  login: (email: string, password: string) =>
    api.post<{ access_token: string; token_type: string }>('/auth/login', { email, password }),

  logout: () => api.post('/auth/logout'),

  me: () => api.get<CurrentUser>('/auth/me'),

  setPassword: (token: string, password: string) =>
    api.post('/auth/set-password', { token, password }),

  changePassword: (currentPassword: string, newPassword: string) =>
    api.patch('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    }),

  completeProfile: (data: { full_name: string; phone: string; personal_data_consent: boolean }) =>
    api.post('/auth/complete-profile', data),

  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email }),
}
